.root {
  padding: var(--rc-theme-spacing-md) var(--rc-theme-spacing-xs);
  border-radius: var(--rc-theme-border-radius-lg);
  background-color: var(--rc-theme-color-primary-default6);
}

.root:hover {
  background-color: var(--rc-theme-color-primary-background);
}

.avatar {
  border: 1px solid var(--rc-theme-color-surface-default);
  background-color: var(--rc-theme-color-surface-subtle);
  color: var(--rc-theme-color-text-default);
}
